import { useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { IoMdRemove, IoMdAdd } from "react-icons/io"

export const MovieTicketPayment: React.FC<any> = ({handleInput, input, back, next, close}) => {
    const [tickets, setTickets] = useState({adult: 0, children: 0, student: 0})

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        next()
    }

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Pay For Ticket</ScreenTitle>
            <CustomContainer topMargin="2.5">
                <Form onSubmit={handleProceed}>
                    <FormGroup>
                        <label>Movie Date & Time</label>
                        <input 
                            placeholder='dd/mm/yyyy' 
                            type='datetime-local'
                            name='movieDateTime'
                            style={{color: input.movieDateTime ? '#000000' : '#667085'}}
                            value={input.movieDateTime}
                            onChange={(e) => handleInput('movieDateTime', e.target.value)}
                            autoComplete="off"
                            required
                        />
                    </FormGroup>
                    <CustomContainer>
                        <AppSpan>Select number of tickets</AppSpan>
                        <GridContainer
                            minHeight='7.2'
                            style={{borderBottom: '1px solid #E8E8E8'}}   
                        >
                            <FlexRow justifyContent='space-between' gap='2'>
                                <AppText textSize='1.8'>Adults</AppText>
                                <FlexRow width='auto' sizeUnit='' gap='1'>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTickets({...tickets, adult: tickets.adult - 1})}
                                    >
                                        <IoMdRemove style={{color: '#007EFF'}} />
                                    </Circle>
                                    <AppText textSize='1.64' fontWeight='500' fontFamily='Montserrat'>{tickets.adult}</AppText>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTickets({...tickets, adult: tickets.adult + 1})}
                                    >
                                        <IoMdAdd style={{color: '#007EFF'}} />
                                    </Circle>
                                </FlexRow>
                            </FlexRow>
                        </GridContainer>
                        <GridContainer
                            minHeight='7.2'
                            style={{borderBottom: '1px solid #E8E8E8'}}   
                        >
                            <FlexRow justifyContent='space-between' gap='2'>
                                <AppText textSize='1.8'>Student</AppText>
                                <FlexRow width='auto' sizeUnit='' gap='1'>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTickets({...tickets, student: tickets.student - 1})}
                                    >
                                        <IoMdRemove style={{color: '#007EFF'}} />
                                    </Circle>
                                    <AppText textSize='1.64' fontWeight='500' fontFamily='Montserrat'>{tickets.student}</AppText>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTickets({...tickets, student: tickets.student + 1})}
                                    >
                                        <IoMdAdd style={{color: '#007EFF'}} />
                                    </Circle>
                                </FlexRow>
                            </FlexRow>
                        </GridContainer>
                        <GridContainer
                            minHeight='7.2' bottomMargin="2"
                            style={{borderBottom: '1px solid #E8E8E8'}}   
                        >
                            <FlexRow justifyContent='space-between' gap='2'>
                                <AppText textSize='1.8'>Children</AppText>
                                <FlexRow width='auto' sizeUnit='' gap='1'>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTickets({...tickets, children: tickets.children - 1})}
                                    >
                                        <IoMdRemove style={{color: '#007EFF'}} />
                                    </Circle>
                                    <AppText textSize='1.64' fontWeight='500' fontFamily='Montserrat'>{tickets.children}</AppText>
                                    <Circle 
                                        borderColor='#DBDDE0' size='3.7' hoverBgColor='#E8E8E8'
                                        onClick={() => setTickets({...tickets, children: tickets.children + 1})}
                                    >
                                        <IoMdAdd style={{color: '#007EFF'}} />
                                    </Circle>
                                </FlexRow>
                            </FlexRow>
                        </GridContainer>
                    </CustomContainer>
                    <FormGroupWithIcon>
                        <label>Payment Account</label>
                        <div className="input-with-icon">
                            <select 
                                name='accountNo'
                                value={input.accountNo}
                                style={{color: input.accountNo ? '#000000' : '#667085'}}
                                onChange={(e) => handleInput('accountNo', e.target.value)}
                                required
                            >
                                <option value="">Select Account</option>
                                <option value="2236728192">Qore - 2236728192</option>
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FlexRow justifyContent='flex-end' gap="1.5" topMargin='2'>
                        <Button 
                            width='6.7' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={back}
                        >
                            Back
                        </Button>
                        <Button 
                            width='11' height='4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Buy Ticket
                        </Button>
                    </FlexRow>
                </Form>
            </CustomContainer>
        </SidePopupLayout>
    )
}